var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import { ReactElementFactory } from "../../element-factory";
import { SurveyElementBase } from "../../reactquestion_element";
import { SvgIcon } from "../svg-icon/svg-icon";
import { SurveyAction } from "../action-bar/action-bar-item";
var SurveyBreadcrumbs = /** @class */ (function (_super) {
    __extends(SurveyBreadcrumbs, _super);
    function SurveyBreadcrumbs(props) {
        return _super.call(this, props) || this;
    }
    SurveyBreadcrumbs.prototype.getStateElement = function () {
        return this.props.model;
    };
    Object.defineProperty(SurveyBreadcrumbs.prototype, "items", {
        get: function () {
            return this.props.model.actions;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SurveyBreadcrumbs.prototype, "css", {
        get: function () {
            return this.props.css;
        },
        enumerable: false,
        configurable: true
    });
    SurveyBreadcrumbs.prototype.renderElement = function () {
        if (!this.items || !this.items.length)
            return null;
        var items = this.renderItems();
        return (React.createElement("div", { className: this.css.breadcrumbsRoot }, items));
    };
    SurveyBreadcrumbs.prototype.renderItems = function () {
        var _this = this;
        var result = [];
        this.items.concat([]).forEach(function (item, itemIndex) {
            if (itemIndex) {
                result.push(React.createElement(SvgIcon, { key: item.renderedId + "_separator", className: _this.css.breadcrumbsSeparator, iconName: "arrowright-16x16", size: "auto" }));
            }
            result.push(React.createElement(SurveyAction, { key: item.renderedId, item: item }));
        });
        return result;
    };
    return SurveyBreadcrumbs;
}(SurveyElementBase));
export { SurveyBreadcrumbs };
ReactElementFactory.Instance.registerElement("sv-breadcrumbs", function (props) {
    return React.createElement(SurveyBreadcrumbs, props);
});
